<script setup>
import BackButton from 'dashboard/components/widgets/BackButton.vue';

defineProps({
  headerTitle: {
    required: true,
    type: String,
  },
  headerDescription: {
    type: String,
    default: '',
  },
  hasBackButton: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <section class="flex flex-col gap-1 pt-6 pb-5">
    <div v-if="hasBackButton">
      <BackButton compact />
    </div>
    <div class="flex flex-col sm:flex-row justify-between w-full gap-4">
      <div class="flex flex-col gap-2 min-w-0">
        <div class="flex flex-col gap-3 items-start">
          <h1
            class="m-0 text-heading-1 text-n-slate-12 min-h-10 flex items-center"
          >
            {{ headerTitle }}
          </h1>
          <p
            v-if="headerDescription"
            class="text-n-slate-11 mb-0 line-clamp-5 sm:line-clamp-none text-body-main"
          >
            {{ headerDescription }}
          </p>
        </div>
      </div>
      <div class="shrink-0 max-w-full self-start sm:self-auto [&>button]:max-w-full [&>button]:whitespace-normal [&>button]:h-auto [&>button]:min-h-8">
        <slot />
      </div>
    </div>
  </section>
</template>
